import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AssetWithUsersV26 } from 'src/app/models-v26/asset-with-users-v26';
import { SwapLicenseOverviewV26 } from 'src/app/models-v26/swap-license-overview-v26';
import { LogService } from 'src/app/services/log-service';
import { environment } from 'src/environments/environment';
import { ApiPath } from '../../configs/api-paths';
import { ActionResponse } from '../../models/action-response';
import { BaseResponse } from '../../models/base-response';
import { PaginatedRequest } from '../../models/paginated-request';
import { NewSwapAssetRequestV26 } from '../../shared-components-v26/allocation-wizard-modal-dialogs/swap-contract-wizard/summary-step/new-swap-asset-request';

@Injectable({
  providedIn: 'root',
})
export class SwapcontractWizardDataV26Service {
  getAssetsWithUsers(request: PaginatedRequest): Observable<BaseResponse<AssetWithUsersV26[]>> {
    const m = this.getAssetsWithUsers.name;

    const path = environment.getEndpoint(ApiPath.V26.Assets.ASSETS_WITHUSERS);
    LogService.info(this, m, LogService.GET + path, null);
    LogService.info(this, m, LogService.REQUEST, request);
    let params = PaginatedRequest.getBaseRequestParams(request);
    const retVal = this.http.get<BaseResponse<AssetWithUsersV26[]>>(path, {
      params,
    });

    return retVal;
  }

  getAssetSwapOverview(swapDate: string, swapAssetId: number, cancelAssetId: number): Observable<BaseResponse<SwapLicenseOverviewV26>> {
    const m = this.getAssetSwapOverview.name;

    const path = environment.getEndpoint(ApiPath.V26.Assets.SWAP_ASSET_WIZARD);
    LogService.info(this, m, LogService.GET + path, null);

    let params = new HttpParams().set('swapDate', swapDate).set('swapAssetId', swapAssetId).set('cancelAssetId', cancelAssetId);
    const retVal = this.http.get<BaseResponse<SwapLicenseOverviewV26>>(path, {
      params,
    });

    return retVal;
  }

  validateSwapLicense(request: NewSwapAssetRequestV26): Observable<BaseResponse<ActionResponse>> {
    const m = this.validateSwapLicense.name;

    const path = environment.getEndpoint(ApiPath.V26.Assets.SWAP_ASSET_VALIDATION);
    LogService.info(this, m, LogService.POST + path, null);

    LogService.info(this, m, LogService.REQUEST, request);
    const retVal = this.http.post<BaseResponse<ActionResponse>>(path, request);

    return retVal;
  }

  swapLicense(request: NewSwapAssetRequestV26): Observable<BaseResponse<ActionResponse>> {
    const m = this.swapLicense.name;

    const path = environment.getEndpoint(ApiPath.V26.Assets.SWAP_ASSET_WIZARD);
    LogService.info(this, m, LogService.POST + path, null);

    LogService.info(this, m, LogService.REQUEST, request);
    const retVal = this.http.post<BaseResponse<ActionResponse>>(path, request);

    return retVal;
  }

  constructor(private http: HttpClient) {}
}
